<template>
    <div class="m-valuation u-pl32 u-pr32">
        <header>
            <span f-font-PFM class="g-fs36 f-bold" s-cr="#323232">估值指标</span>
            <span f-font-PFR class="g-fs28" s-cr="#999999" @click="seeIndex('1')">指标释义<img src="../../assets/images/allow-right.png" alt="#"></span>
        </header>
        <!-- <div class="m-valuation-date g-fs24" f-font-PFM s-cr="#323232">
            <img src="../../assets/images/date.png" alt="#">
            <span>{{time}}</span>
        </div> -->
        <ul>
            <li>
                <span>{{fiveIndex.pe | formatProfit}}</span>
                <span>PE</span>
            </li>
            <li>
                <span>{{fiveIndex.pePercent | formatProfit(true)}}</span>
                <span>PE百分位</span>
            </li>
            <li>
                <span>{{fiveIndex.pb | formatProfit}}</span>
                <span>PB</span>
            </li>
            <li>
                <span>{{fiveIndex.pbPercent | formatProfit(true)}}</span>
                <span>PB百分位</span>
            </li>
            <li>
                <span>{{fiveIndex.roe | formatProfit(true)}}</span>
                <span>ROE</span>
            </li>
        </ul>
        <definition v-if="indexFlag" @definiton="seeIndex"></definition>
    </div>
</template>

<script>
    import Definition from './definition';
    import { config } from '@/assets/js/common.js';
    export default {
        name: "valuation",
        props: {
            time: {
                type: String,
                default: ''
            },
            fiveIndex: {
                type: Object,
                default: () => {
                    return {
                        pe: '--',
                        pePercent: '--',
                        pb: '--',
                        pbPercent: '--',
                        roe: '--',
                    }
                }
            }
        },
        components: {
            Definition
        },
        data() {
            return {
                indexFlag: false
            }
        },
        methods: {
            seeIndex(num = '0') {
                if (config.isSharePage) return;
                _.log().clickStat(num === '1' ? 'shiyi' : 'know');
                this.indexFlag = !this.indexFlag;
                if (this.indexFlag) {
                    document.body.style.overflow = 'hidden';
                } else {
                    document.body.style.overflow = 'auto';
                }
            }
        }
    }
</script>

<style lang="less">
.m-valuation {
    padding-bottom: 40px;
    header {
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        margin-bottom: 18px;
        span:last-child  {
            display: flex;
            align-items: center;
            img {
                width: 16px;
                height: 24px;
                margin-left: 8px;
            }
            
        }
    }
    ul {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        li {
            box-sizing: border-box;
            width: 124px;
            padding: 24px 0 16px 0;
            background: #FAFAFA;
            border-radius: 16px;
            text-align: center;
            span {
                display: block;
                line-height: 32px;
                &:first-child {
                    font-family: THSMoneyfont-Medium;
                    font-size: 32px;
                    color: #323232;
                    margin-bottom: 4px;
                }
                &:last-child {
                    font-family: PingFangSC-Regular;
                    font-size: 24px;
                    color: #666666;
                    font-weight: 400;
                }
            }
        }
    }
    .m-valuation-date {
        display: flex;
        align-items: center;
        img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
        }
    }
}
</style>